type DealerCardProps = { name: string; location: string; website: string };

export default function DealerCard({
  name,
  location,
  website,
}: DealerCardProps) {
  return (
    <div className="card">
      <h2 className="dealer-card__title">{name}</h2>
      <div className="small">{location}</div>
      {website && (
        <p className="small" style={{ marginTop: 8 }}>
          <a href={website} target="_blank" rel="noopener noreferrer">
            Site web de {name}
          </a>
        </p>
      )}
    </div>
  );
}
